import React, { useContext } from "react";
import { FilterContext } from "./context";
import { Tooltip } from "@mui/material";
import { OwcIconButton } from "@one/react";
import { snackbarService } from "@one/web-components/dist/index.cjs.js";
import {SHARE_USER_FILTER_AND_COLUMNS} from "../../../../gql/bookingapi";
import {withApollo} from "react-apollo";


const Actions = ({ item, client, triggerRefresh, setTriggerRefresh }) => {
    const { setDialogOpen, setIsEditMode, setEditData } = useContext(FilterContext);
    return (
        <div style={{ width: "100%", textAlign: "right", display: 'flex' }}>
            <Tooltip
                data-testid={`filter-edit-button-tooltip${item.groupName}`}
                title="Edit assignment"
                placement="left"
                arrow
            >
                <OwcIconButton
                    key={`booking-admin-table-edit-filter-button-${item.groupName}`}
                    data-testid={`booking-admin-table-edit-filter-button-${item.groupName}`}
                    onClick={() => {
                        setIsEditMode(true);
                        const assignedGroupsArray = item.assignedGroups && item.assignedGroups !== "-"
                            ? item.assignedGroups.split(", ").map(group => group.trim())
                            : [];
                        const editData = {
                            filter: {
                              filterName: item.filterName,
                              id: item.id,
                              userID: item.userID,
                              __typename:"UserFilter"
                            },
                            columnSet: {
                              displayName: item.columnSet,
                              id: item.id,
                              userID: item.columnSetOwnerId,
                              __typename:"UserDisplay"
                            },
                            groups: assignedGroupsArray
                        };

                        if (setEditData) {
                            setEditData(editData);
                        }

                        setDialogOpen(true);
                    }}
                    icon="edit"
                    type="legacy"
                    flat
                />
            </Tooltip>

          <Tooltip title="Remove assignment" placement="left" arrow>
            <OwcIconButton
              key={`booking-admin-table-delete-filter-button-${item.groupName}`}
              data-testid={`booking-admin-table-delete-filter-button-${item.groupName}`}
              icon="delete"
              type="legacy"
              flat
              onClick={async () => {
                try {
                  await client.mutate({
                    mutation: SHARE_USER_FILTER_AND_COLUMNS,
                    variables: {
                      input: {
                        previousFilterId: item.filterName ? `EQUIPMENTLIST#${item.filterName}` : null,
                        previousFilterUserID: item.userID ?? null,
                        previousColumnSetId: item.columnSet ? `EQUIPMENTLIST#${item.columnSet}` : null,
                        previousColumnSetUserID: (item.columnSetOwnerId || item.userID) ?? null,
                        groupIds: item.sharedWithGroups
                      },
                    },
                    fetchPolicy: 'no-cache',
                  });

                  snackbarService.show({
                    message: "Assignment removed successfully.",
                    type: "success",
                  });
                  if (setTriggerRefresh) {
                    triggerRefresh();
                  }
                } catch (err) {
                  console.error("Error removing assignment:", err);
                  snackbarService.show({
                    message: "Failed to remove assignment.",
                    type: "error",
                  });
                }
              }}
            />
          </Tooltip>
        </div>
    );
};

export default withApollo(Actions);
